<template>
  <div v-title :data-title="$route.name">
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative; display: inline-block; width: 100%">
        <!-- <img
          style="width: 100%"
          src="../assets/Battertimg/PC/contactusbeijing.jpg"
          alt=""
        /> -->
        <!-- <img
          style="width: 100%"
          src="../assets/Battertimg/PC/contactsusbjcopy.png"
          alt=""
        /> -->
        <img
          style="width: 100%"
          src="../assets/Battertimg/PC/contacttop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ffffff !important;
            font-size: 48px;
            font-family: Cotyledon-Regular-bold;
            text-align: center;
            width: 100%;
          "
        >
          <!-- text-shadow: rgba(0, 0, 0, 0.5) 2px 2px 4px; -->
          Contact us
        </div>
        <!-- 修改后的三个等宽白框 -->
        <div class="contact-boxes">
          <div class="contact-box">
            <div class="box-row">
              <img
                src="../assets/Battertimg/PC/phoneicon.png"
                style="width: 20px; height: 20px"
              />
            </div>
            <div class="box-row">
              <span>Phone</span>
            </div>
            <div class="box-content">
              <span>(04) 5245 7579</span>
            </div>
          </div>

          <div class="contact-box">
            <div class="box-row">
              <img
                src="../assets/Battertimg/PC/emailicon.png"
                style="width: 20px; height: 20px"
              />
            </div>
            <div class="box-row">
              <span>E-mail</span>
            </div>
            <div class="box-content">
              <span>info@batteryplant.com.au</span>
            </div>
          </div>
          <div class="contact-box">
            <div class="box-row">
              <img
                src="../assets/Battertimg/PC/addressicon.png"
                style="width: 20px; height: 25px"
              />
            </div>
            <div class="box-row">
              <span>Head Office Address</span>
            </div>
            <div class="box-content">
              <span>203 Blackburn Rd Mount Waverley VIC 3149</span>
            </div>
          </div>
        </div>
      </div>

      <div style="position: relative; width: 100%">
        <div
          style="background-color: white; height: 80px"
          class="kongbai"
        ></div>
        <img
          style="width: 100%"
          src="../assets/Battertimg/PC/PCDIQIUCOPY.png"
          alt=""
        />
        <div class="form-header">
          Get Your Free Residential Solar & Battery Quote
        </div>
        <div class="form-title">
          Fill out the form below and our team will contact you shortly.
        </div>
        <!-- 新增表单区域 -->
        <div class="form-container">
          <el-form
            ref="form"
            :model="form"
            label-width="120px"
            label-position="top"
            class="contact-form"
            :rules="addUserRule"
          >
            <div class="form-row">
              <el-form-item
                label="First Name"
                class="form-item-left"
                prop="FirstName"
              >
                <el-input
                  v-model="form.FirstName"
                  placeholder="First Name*"
                  clearable
                  class="rounded-input"
                />
              </el-form-item>
              <el-form-item
                label="Last Name"
                class="form-item-left"
                prop="LastName"
              >
                <el-input
                  v-model="form.LastName"
                  placeholder="Last Name*"
                  clearable
                  class="rounded-input"
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="Phone" class="form-item-left" prop="Phone">
                <el-input
                  v-model="form.Phone"
                  placeholder="Phone*"
                  class="rounded-input"
                  clearable
                />
              </el-form-item>
              <el-form-item label="E-mail" prop="Email" class="full-width-item">
                <el-input
                  v-model="form.Email"
                  placeholder="E-mail"
                  class="rounded-input"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="form-single-row">
              <el-form-item
                label="Address / Postcode"
                class="full-width-item"
                prop="Address"
              >
                <el-input
                  placeholder="Installation Address/Postcode*"
                  v-model="form.Address"
                  @focus="geolocate()"
                  name="autocomplete"
                  id="autocompletepc"
                  autocomplete="off"
                  clearable
                  class="rounded-input"
                />
              </el-form-item>
            </div>
            <div class="form-row">
              <div style="padding-left: 10px !important">
                <!-- <div style="font-size: 12px !important">Interested In:</div> -->
                <el-form-item label="Interested In:" prop="InterestedGroup">
                  <el-radio-group
                    v-model="form.InterestedGroup"
                    style="
                      display: flex !important;
                      flex-direction: column !important;
                      margin-top: 10px !important;
                    "
                  >
                    <el-radio key="Solar" label="Solar">Solar</el-radio>
                    <el-radio key="Battery" label="Battery">Battery</el-radio>
                    <el-radio key="Solar+Battery" label="Solar+Battery"
                      >Solar+Battery</el-radio
                    >
                  </el-radio-group></el-form-item
                >
              </div>
              <el-form-item
                label="Enquiry Type"
                prop="EnquiryType"
                class="full-width-item"
              >
                <el-select
                  v-model="form.EnquiryType"
                  placeholder="Pleast Select"
                  clearable
                  class="rounded-input full-width-select"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option> </el-select
              ></el-form-item>
            </div>
            <!-- <div class="form-single-row">
              <el-form-item
                label="Message"
                prop="Message"
                class="full-width-item"
              >
                <el-input
                  v-model="form.Message"
                  type="textarea"
                  class="rounded-input message-textarea"
                  clearable
                  :autosize="{ minRows: 4, maxRows: 8 }"
                ></el-input>
              </el-form-item>
            </div> -->
            <el-form-item class="submit-button">
              <el-button
                type="primary"
                @click="submitForm"
                class="gradient-button"
                :disabled="isSubmitting"
              >
                Submit
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div></div>
      <div style="background-color: white; height: 120px" class="kongbai"></div>
      <div class="form-footer">
        <div class="form-footer-title">FAQ</div>
        <div class="form-footer-littletitle">
          Q: How much can l save with solar?
        </div>
        <div class="form-footer-neirong">
          A: Savings depend on your electricity usage and system size, but many
          households significantly reduce their power bills after installation -
          apply this.
        </div>
        <div class="form-footer-littletitle">Q: ls battery storage safe?</div>
        <div class="form-footer-neirong">
          A: Yes. We install approved battery systems and follow strict safety
          standards.
        </div>
        <div class="form-footer-littletitle">
          Q: How long does installation take?
        </div>
        <div class="form-footer-neirong">
          A: Most residential systems can be installed within a Day or two.
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        border: 1px solid #f8f9fa;
        overflow: hidden;
        position: relative;
        background-color: white;
      "
    >
      <div style="position: relative; display: inline-block; width: 100%">
        <!-- <img
          style="width: 100%"
          src="../assets/Battertimg/H5/h5lianxiwomen.jpg"
          alt=""
        /> -->
        <!-- <img
          style="width: 100%"
          src="../assets/Battertimg/H5/contactusbjcopy.png"
          alt=""
        /> -->
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/contacttop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ffffff !important;
            font-size: 28px;
            font-family: Cotyledon-Regular-bold;
            text-align: center;
            width: 100%;
          "
        >
          Contact Us
        </div>
      </div>
      <!-- 移动端三个白框 - 竖排排列，高度调整为26%，内部三行等分 -->
      <div class="mobile-contact-boxes">
        <div class="mobile-contact-box">
          <div class="mobile-box-icon">
            <img src="../assets/Battertimg/PC/phoneicon.png" alt="Phone" />
          </div>
          <div class="mobile-box-title">
            <span>Phone</span>
          </div>
          <div class="mobile-box-content">
            <span>(04) 5245 7579</span>
          </div>
        </div>

        <div class="mobile-contact-box">
          <div class="mobile-box-icon">
            <img src="../assets/Battertimg/PC/emailicon.png" alt="Email" />
          </div>
          <div class="mobile-box-title">
            <span>E-mail</span>
          </div>
          <div class="mobile-box-content">
            <span>info@batteryplant.com.au</span>
          </div>
        </div>

        <div class="mobile-contact-box">
          <div class="mobile-box-icon">
            <img src="../assets/Battertimg/PC/addressicon.png" alt="Address" />
          </div>
          <div class="mobile-box-title">
            <span>Head Office Address</span>
          </div>
          <div class="mobile-box-content">
            <span>203 Blackburn Rd Mount Waverley VIC 3149</span>
          </div>
        </div>
      </div>
      <!-- 移动端地球背景和表单 - 表单位置下移 -->
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/H5diqiu.jpg"
          alt=""
        />
        <div class="mobile-form-header">
          Get Your Free Residential Solar & Battery Quote
        </div>
        <div class="mobile-form-title">
          Fill out the form below and our team<br />
          will contact you shortly.
        </div>
        <!-- 移动端表单区域 - 位置下移 -->
        <div class="mobile-form-container">
          <el-form
            ref="form"
            :model="form"
            label-width="120px"
            label-position="top"
            class="mobile-contact-form"
            :rules="addUserRule"
          >
            <!-- 移动端表单行改为单列 -->
            <div class="mobile-form-item">
              <el-form-item label="First Name" prop="FirstName">
                <el-input
                  v-model="form.FirstName"
                  placeholder="First Name*"
                  clearable
                  class="mobile-rounded-input"
                />
              </el-form-item>
            </div>
            <div class="mobile-form-item">
              <el-form-item label="Last Name" prop="LastName">
                <el-input
                  v-model="form.LastName"
                  placeholder="Last Name*"
                  clearable
                  class="mobile-rounded-input"
                />
              </el-form-item>
            </div>

            <div class="mobile-form-item">
              <el-form-item label="Phone" prop="Phone">
                <el-input
                  v-model="form.Phone"
                  placeholder="Phone*"
                  class="mobile-rounded-input"
                  clearable
                />
              </el-form-item>
            </div>

            <div class="mobile-form-item">
              <el-form-item label="Address/Postcode" prop="Address">
                <el-input
                  placeholder="Installation Address/Postcode*"
                  v-model="form.Address"
                  @focus="geolocate()"
                  name="autocomplete"
                  id="autocompleteh5"
                  autocomplete="off"
                  clearable
                  class="mobile-rounded-input"
                />
              </el-form-item>
            </div>

            <div class="mobile-form-item">
              <el-form-item label="E-mail" prop="Email">
                <el-input
                  v-model="form.Email"
                  placeholder="E-mail"
                  class="mobile-rounded-input"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="mobile-form-item" style="text-align: left">
              <!-- <div style="font-size: 12px !important">Interested In:</div> -->
              <el-form-item label="Interested In:" prop="InterestedGroup">
                <el-radio-group
                  v-model="form.InterestedGroup"
                  style="
                    display: flex !important;
                    flex-direction: column !important;
                    margin-top: 10px !important;
                  "
                >
                  <el-radio key="Solar" label="Solar">Solar</el-radio>
                  <el-radio key="Battery" label="Battery">Battery</el-radio>
                  <el-radio key="Solar+Battery" label="Solar+Battery"
                    >Solar+Battery</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="mobile-form-item">
              <el-form-item label="Enquiry Type" prop="EnquiryType">
                <el-select
                  v-model="form.EnquiryType"
                  placeholder="Pleast Select"
                  clearable
                  class="mobile-rounded-input mobile-full-width-select"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- <div class="mobile-form-item">
              <el-form-item label="Message" prop="Message">
                <el-input
                  v-model="form.Message"
                  type="textarea"
                  class="mobile-rounded-input mobile-message-textarea"
                  clearable
                  :autosize="{ minRows: 4, maxRows: 8 }"
                ></el-input>
              </el-form-item>
            </div> -->

            <el-form-item class="mobile-submit-button">
              <el-button
                type="primary"
                @click="submitForm"
                class="mobile-gradient-button"
                :disabled="isSubmitting"
              >
                Submit
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div style="background-color: white; height: 550px" class="kongbai"></div>
      <div class="mobileform-footer" style="margin-top: 10px">
        <div class="mobileform-footer-title">FAQ</div>
        <div class="mobileform-footer-littletitle">
          Q: How much can l save with solar?
        </div>
        <div class="mobileform-footer-neirong">
          A: Savings depend on your electricity usage and system size, but many
          households significantly reduce their power bills after installation -
          apply this.
        </div>
        <div class="mobileform-footer-littletitle">
          Q: ls battery storage safe?
        </div>
        <div class="mobileform-footer-neirong">
          A: Yes. We install approved battery systems and follow strict safety
          standards.
        </div>
        <div class="mobileform-footer-littletitle">
          Q: How long does installation take?
        </div>
        <div class="mobileform-footer-neirong">
          A: Most residential systems can be installed within a Day or two.
        </div>
      </div>
      <!-- 底部导航 -->
      <!-- 在移动端部分（v-else内）修改底部导航栏 -->
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">
              203 Blackburn Rd Mount Waverley VIC 3149
            </div>
          </div>
        </div>
      </footer>
    </div>
    <GMaps
      v-show="false"
      class="Gmaps"
      @fun="getinfo"
      :offsetwidth="offsetwidth"
      ref="child"
      :map-data="mapData"
    />
  </div>
</template>

<script>
import GMaps from "../H5/map/Gmaps.vue";
import { get, post } from "../assets/api/api";
import { OrdersIntentionDown, ContactUsSubmit } from "../assets/api/request.js";
export default {
  components: { GMaps },
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    const regemail = (rule, value, callback) => {
      let reg =
        /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (!reg.test(value) && value) {
        return callback(new Error("The email format is not correct."));
      }
      callback();
    };
    const notNull = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        return callback(new Error(`${rule.field} is required `));
      }
      callback();
    };
    const checkPhone = (rule, value, callback) => {
      let reg = /^[0][3,4][0-9]{8}$/;
      if (!reg.test(value)) {
        return callback(new Error(`Please provide a valid Phone number. `));
      }
      callback();
    };
    return {
      isSubmitting: false,
      activeNav: null, // 跟踪当前激活的导航项
      options: [],
      mapData: {
        latitude: 33.242,
        longitude: 124.12,
      },
      form: {
        FirstName: "",
        LastName: "",
        Address: "",
        Phone: "",
        Email: "",
        EnquiryType: "",
        InterestedGroup: "",
        Message: "",
        Suburb: "",
        Postcode: "",
        streetName: "",
        Street_number: "",
        City: "",
      },
      addUserRule: {
        FirstName: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        LastName: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        Address: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        EnquiryType: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        InterestedGroup: [
          {
            validator: notNull,
            message: "Interested In is required",
            trigger: ["change", "blur"],
          },
        ],
        Email: [
          // {
          //   validator: notNull,
          //   trigger: ["change", "blur"],
          // },
          {
            validator: regemail,
            message: "Please enter a valid email address.",
            trigger: ["change", "blur"],
          },
        ],
        Phone: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
          {
            validator: checkPhone,
            len: 10,
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },

  mounted() {
    document.documentElement.scrollTop = 0;
    this.getOrdersIntentionDown();
    // window.fbq("track", "ViewContent", {
    //   content_type: "Contact Us",
    //   content_ids: ["10005"],
    //   content_name: "Contact Us",
    //   content_category: "Contact Us",
    // });
  },
  methods: {
    getOrdersIntentionDown() {
      get(OrdersIntentionDown).then((res) => {
        if (res.data.code == 200) {
          this.options = res.data.data;
        }
      });
    },
    geolocate() {
      this.$refs.child.geolocate;
    },
    initAutocomplete() {
      this.$refs.child.initAutocomplete;
    },
    fillInAddress() {
      this.$refs.child.fillInAddress;
    },
    //获取组件中的谷歌地图信息
    getinfo(data) {
      console.log(data);
      if (data.tag == "placepc" || data.tag == "placeh5") {
        this.form.Address = data.address;
        this.form.Suburb = data.locality;
        this.form.Postcode = data.postal_code;
        this.form.streetName = data.route;
        this.form.Street_number = data.street_number;
        this.form.City = data.administrative_area_level_2;
        if (this.form.streetName === "long_name") {
          this.form.streetName = "";
        }
        if (this.form.Suburb === "long_name") {
          this.form.Suburb = "";
        }
        if (this.form.Street_number === "short_name") {
          this.form.Street_number = "";
        }
        if (this.form.Postcode === "short_name") {
          this.form.Postcode = "";
        }
        if (this.form.City === "short_name") {
          this.form.City = "";
        }
      }
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 设置提交状态为 true
          this.isSubmitting = true;
          let IntentionName;
          if (this.form.EnquiryType) {
            this.options.forEach((item) => {
              if (item.Id == this.form.EnquiryType) {
                IntentionName = item.Name;
              }
            });
          }
          let leadsfromcopy;
          if (!this.$route.query.leadsfrom) {
            leadsfromcopy = "batteryplant";
          } else {
            leadsfromcopy = this.$route.query.leadsfrom;
          }

          let formdata = {
            FirstName: this.form.FirstName,
            LastName: this.form.LastName,
            Address: this.form.Address,
            PhoneNumber: this.form.Phone,
            Email: this.form.Email,
            Intention: this.form.EnquiryType,
            IntentionName: IntentionName,
            Message: this.form.InterestedGroup,
            leadsfrom: leadsfromcopy,
          };
          console.log(formdata);
          post(ContactUsSubmit, formdata)
            .then((res) => {
              if (res.data.code == 200) {
                this.form = {};
                this.$message.success("Successful.");
              } else {
                // 返回不是200，放开按钮可用
                this.isSubmitting = false;
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  duration: 2500,
                });
              }
            })
            .catch((error) => {
              // 请求失败，放开按钮可用
              this.isSubmitting = false;
              this.$message({
                type: "error",
                message: "Submission failed. Please try again.",
                duration: 2500,
              });
              console.error("Submit error:", error);
            });
        }
      });
    },
    gotobooknow() {
      const routeUrl = this.$router.resolve({ path: "/CustomerDetails" });
      window.open(routeUrl.href, "_blank");
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/ContactUs");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* 不同屏幕下的导航栏宽度 */
@media (min-width: 1920px) {
  // 1.6
  .form-header {
    top: 16% !important;
  }
  .box-row {
    font-size: 28px !important;
  }
  .box-content {
    font-size: 19px !important;
  }
  .form-header {
    font-size: 38px !important;
  }
  .contact-form .el-form-item__label {
    font-size: 21px !important;
  }
  .rounded-input .el-input__inner {
    font-size: 21px !important;
  }
}
@media (min-width: 1600px) and (max-width: 1919px) {
  // 1.4
  .box-row {
    font-size: 25px !important;
  }
  .box-content {
    font-size: 16px !important;
  }
  .form-header {
    font-size: 33px !important;
    top: 15% !important;
  }
  .form-title {
    top: 20% !important;
    font-size: 16px !important;
  }
  .form-footer-title {
    font-size: 25px !important;
  }
  .form-footer-neirong,
  .form-footer-littletitle {
    font-size: 16px !important;
  }
  .contact-form .el-form-item__label {
    font-size: 18px !important;
  }
  .rounded-input .el-input__inner {
    font-size: 18px !important;
  }
}

@media (min-width: 1440px) and (max-width: 1600px) {
  // 1.26
}

@media (min-width: 1301px) and (max-width: 1439px) {
  // 1.14
  .battery-home-header .nav-content {
    width: 1141px !important;
    height: 47px !important;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .box-row {
    font-size: 18px !important;
  }
  .box-content {
    font-size: 12px !important;
  }
  .form-header {
    font-size: 24px !important;
  }
  .contact-form .el-form-item__label {
    font-size: 15px !important;
  }
  .rounded-input .el-input__inner {
    font-size: 15px !important;
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>
<style scoped>
@media (max-width: 800px) and (min-width: 501px) {
  .kongbai {
    display: none;
  }
}
/* 移动端三个白框样式 - 竖排排列，高度调整为26%，内部三行等分，内容左对齐 */
.mobile-contact-boxes {
  /* position: absolute;
  top: 7%; 
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  width: 90%;
  gap: 15px;
  z-index: 10; */
  position: absolute;
  top: 7%;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  width: 85.6%; /* 642/750 = 85.6% */
  gap: 4.27%; /* 32/750 = 4.27% */
  z-index: 10;
}

.mobile-contact-box {
  /* background: white;
  border-radius: 12px;
  padding: 0; 
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: left; 
  border: 1px solid #e0e0e0;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 110px; 
  min-height: 110px; */
  background: white;
  border-radius: 12px;
  padding: 0;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: left;
  border: 1px solid #e0e0e0;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 25.07vw; /* 188/750 = 25.07% */
  min-height: 188px; /* 基准高度 */
}

/* 内部三行等分布局 - 左对齐 */
.mobile-box-icon,
.mobile-box-title,
.mobile-box-content {
  /* display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-height: 30px;
  padding-left: 20px;  */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-height: 30px;
  padding-left: 5.33%; /* 40/750 = 5.33% */
}

.mobile-box-icon {
  /* padding-top: 10px; */
  padding-top: 3.33%; /* 25/750 = 3.33% */
}

.mobile-box-icon img {
  /* width: 20px; */
  /* height: 22px; */
  width: 5.33vw; /* 40/750 = 5.33% */
  max-width: 40px;
  height: auto;
}

.mobile-box-title {
  /* font-size: 16px;
   font-family: Cotyledon-Regular-bold;
  color: #2c3e50;
  padding: 0 20px; */
  font-size: 4.27vw; /* 32/750 = 4.27% */
  font-family: Cotyledon-Regular-bold;
  color: #2c3e50;
  padding: 0 5.33%;
}

.mobile-box-content {
  /* font-size: 14px;
  word-wrap: break-word;
  line-height: 1.3;
  padding: 0 20px 10px; 
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;  */
  font-size: 3.73vw; /* 28/750 = 3.73% */
  word-wrap: break-word;
  line-height: 1.3;
  padding: 0 5.33% 3.33%;
  align-items: flex-start;
  justify-content: flex-start;
}

/* 移动端表单样式 - 位置特别往下200px */
.mobile-form-container {
  /* position: absolute;
  top: 44%;
  left: 50%;
  transform: translateX(-50%); 
  width: 90%;
  background: rgba(255, 255, 255,0.91);
  border-radius: 12px;
  padding: 15px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10; */
  position: absolute;
  top: 76%; /* (188+32+120+40)/750 ≈ 50.67%，根据实际布局调整到76% */
  left: 50%;
  transform: translateX(-50%);
  width: 85.6%; /* 642/750 = 85.6% */
  background: rgba(255, 255, 255, 0.91);
  border-radius: 12px;
  padding: 4%; /* 30/750 = 4% */
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.mobile-form-header {
  /* position: absolute;
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  text-align: center;
  font-size: 24px !important;
  font-family: Cotyledon-Regular-bold;
  margin-bottom: 20px;
  color: #2c3e50; */
  position: absolute;
  top: 56%; /* (188+32+120)/750 ≈ 45.33%，调整到56% */
  left: 50%;
  transform: translateX(-50%);
  width: 85.6%;
  text-align: center;
  font-size: 6.4vw !important; /* 48/750 = 6.4% */
  font-family: Cotyledon-Regular-bold;
  margin-bottom: 5.33%; /* 40/750 = 5.33% */
  color: #2c3e50;
}
.mobile-form-title {
  position: absolute;
  top: 53%; /* (188+32+120)/750 ≈ 45.33%，调整到56% */
  left: 50%;
  transform: translateX(-50%);
  width: 85.6%;
  text-align: center;
  font-size: 14px; /* 48/750 = 6.4% */
  margin-bottom: 5.33%; /* 40/750 = 5.33% */
  color: #2c3e50;
}
.mobile-contact-form {
  display: flex;
  flex-direction: column;
}

.mobile-form-item {
  margin-bottom: 12px;
}

/* 移动端输入框样式 */
::v-deep.mobile-rounded-input .el-input__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  width: 100% !important;
  font-size: 14px;
}

.mobile-full-width-select {
  width: 100% !important; /* 使用 !important 确保覆盖 */
  max-width: 100%; /* 防止超出父容器 */
  box-sizing: border-box; /* 重要的盒模型设置 */
}
::v-deep.mobile-full-width-select .el-input__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  width: 100% !important;
}

/* 移动端文本域样式 */
::v-deep.mobile-message-textarea .el-textarea__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  resize: none !important;
  min-height: 120px !important;
  font-family: inherit !important;
  line-height: 1.5 !important;
  width: 100% !important;
}

/* 移动端按钮样式 */
.mobile-gradient-button {
  padding: 12px 40px;
  border: none;
  border-radius: 50px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  background: linear-gradient(to right, #007bff, #28a745);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 40%;
}

.mobile-submit-button {
  margin-top: 30px;
  text-align: center;
}

/* 移动端标签样式 */
::v-deep.mobile-contact-form .el-form-item__label {
  text-align: left !important;
  display: block !important;
  width: 100% !important;
  padding-bottom: 8px !important;
  color: #2c3e50 !important;
  font-weight: normal !important;
  line-height: 25px !important;
  font-size: 14px !important;
  font-family: Cotyledon-Regular;
}
/* 响应式断点适配 */

/* 超小屏手机 (iPhone 5/SE) - 320px */
@media (max-width: 320px) {
  .mobile-contact-boxes {
    top: 5%;
    width: 90%;
    gap: 3%;
  }

  .mobile-contact-box {
    height: 180px;
    min-height: 180px;
  }

  .mobile-box-title {
    font-size: 14px;
  }

  .mobile-box-content {
    font-size: 12px;
  }

  .mobile-form-header {
    font-size: 20px !important;
    top: 52%;
  }
  .mobile-form-title {
    font-size: 12px !important;
  }
  .mobileform-footer-title {
    font-size: 14px !important;
  }
  .mobile-form-container {
    top: 72%;
    width: 90%;
  }
}

/* 小屏手机 - 321px to 375px */
@media (min-width: 321px) and (max-width: 375px) {
  .mobile-contact-boxes {
    top: 6%;
    width: 88%;
    gap: 3.5%;
  }

  .mobile-contact-box {
    height: 175px;
    min-height: 175px;
  }

  .mobile-box-title {
    font-size: 15px;
  }

  .mobile-box-content {
    font-size: 13px;
  }

  .mobile-form-header {
    font-size: 22px !important;
    top: 47% !important;
  }
  .mobile-form-title {
    font-size: 13px !important;
    top: 56% !important;
  }
  .mobileform-footer-title {
    font-size: 22px !important;
  }
  .mobileform-footer-littletitle {
    font-size: 14px !important;
  }
  .mobileform-footer-neirong {
    font-size: 14px !important;
  }
  .mobile-form-container {
    top: 74%;
    width: 88%;
  }
}

/* 中屏手机 (iPhone 6/7/8/X) - 376px to 414px */
@media (min-width: 376px) and (max-width: 414px) {
  .mobile-contact-boxes {
    top: 7%;
    width: 86%;
    gap: 4%;
  }

  .mobile-contact-box {
    height: 185px;
    min-height: 185px;
  }

  .mobile-box-title {
    font-size: 16px;
  }

  .mobile-box-content {
    font-size: 14px;
  }

  .mobile-form-header {
    font-size: 24px !important;
    top: 43% !important;
  }
  .mobile-form-title {
    font-size: 14px !important;
    top: 52% !important;
  }
  .mobileform-footer-title {
    font-size: 20px !important;
  }
  .mobileform-footer-littletitle {
    font-size: 14px !important;
  }
  .mobileform-footer-neirong {
    font-size: 14px !important;
  }
  .mobile-form-container {
    top: 75%;
    width: 86%;
  }
}

/* 大屏手机 - 415px to 480px */
@media (min-width: 415px) and (max-width: 480px) {
  .mobile-contact-boxes {
    top: 8%;
    width: 84%;
    gap: 4.2%;
  }

  .mobile-contact-box {
    height: 190px;
    min-height: 190px;
  }

  .mobile-box-title {
    font-size: 17px;
  }

  .mobile-box-content {
    font-size: 15px;
  }

  .mobile-form-header {
    font-size: 26px !important;
    top: 40% !important;
  }
  .mobile-form-title {
    font-size: 15px !important;
    top: 49% !important;
  }
  .mobileform-footer-title {
    font-size: 20px !important;
  }
  .mobileform-footer-littletitle {
    font-size: 15px !important;
  }
  .mobileform-footer-neirong {
    font-size: 15px !important;
  }
  .mobile-form-container {
    top: 76%;
    width: 84%;
  }
}

/* 小屏平板 - 481px to 768px */
@media (min-width: 481px) and (max-width: 768px) {
  .mobile-contact-boxes {
    top: 10%;
    width: 82%;
    gap: 4.5%;
  }

  .mobile-contact-box {
    height: 200px;
    min-height: 200px;
  }

  .mobile-box-title {
    font-size: 18px;
  }

  .mobile-box-content {
    font-size: 16px;
  }

  .mobile-form-header {
    font-size: 28px !important;
    top: 58%;
  }
  .mobile-form-title {
    font-size: 16px !important;
  }
  .mobileform-footer-title {
    font-size: 20px !important;
  }
  .mobileform-footer-littletitle {
    font-size: 16px !important;
  }
  .mobileform-footer-neirong {
    font-size: 16px !important;
  }
  .mobile-form-container {
    top: 78%;
    width: 82%;
    padding: 35px;
  }

  .mobile-box-icon,
  .mobile-box-title,
  .mobile-box-content {
    padding-left: 30px;
  }

  .mobile-box-icon {
    padding-top: 20px;
  }

  .mobile-box-content {
    padding: 0 30px 20px;
  }
}

/* 输入框和表单元素的响应式调整 */
@media (max-width: 480px) {
  ::v-deep.mobile-rounded-input .el-input__inner {
    padding: 10px 12px !important;
    font-size: 14px !important;
  }

  ::v-deep.mobile-message-textarea .el-textarea__inner {
    padding: 10px 12px !important;
    min-height: 100px !important;
  }

  .mobile-gradient-button {
    padding: 10px 35px;
    font-size: 14px;
    width: 50%;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  ::v-deep.mobile-rounded-input .el-input__inner {
    padding: 14px 16px !important;
    font-size: 14px !important;
  }

  ::v-deep.mobile-message-textarea .el-textarea__inner {
    padding: 14px 16px !important;
    min-height: 140px !important;
  }

  .mobile-gradient-button {
    padding: 14px 45px;
    font-size: 16px;
    width: 45%;
  }
}

/* 确保在横屏模式下的适配 */
@media (max-height: 500px) and (orientation: landscape) {
  .mobile-contact-boxes {
    top: 5%;
    gap: 2%;
  }

  .mobile-contact-box {
    height: 140px;
    min-height: 140px;
  }

  .mobile-form-header {
    top: 50%;
  }

  .mobile-form-container {
    top: 70%;
    padding: 20px;
  }
}

/* 高分辨率屏幕适配 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .mobile-contact-box {
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .mobile-form-container {
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.1);
  }
}

@media (min-width: 480px) and (max-width: 850px) {
  .mobile-contact-boxes {
    width: 85%;
    gap: 12px;
    top: 12%; /* 保持26% */
  }
}
/* 响应式调整 */
@media (max-width: 480px) {
  .mobile-contact-boxes {
    width: 85%;
    gap: 12px;
    top: 4%; /* 保持26% */
  }

  .mobile-contact-box {
    height: 110px;
    min-height: 110px;
  }

  .mobile-box-icon img {
    width: 20px;
    /* height: 22px; */
  }

  .mobile-box-title {
    font-size: 15px;
    padding: 0 15px; /* 小屏幕调整内边距 */
  }

  .mobile-box-content {
    font-size: 12px;
    padding: 0 15px 8px; /* 小屏幕调整内边距 */
  }

  .mobile-form-container {
    width: 85%;
    padding: 20px 15px;
    top: 62%; /* 保持200px下移 */
  }
  .mobile-form-title {
    font-size: 12px;
  }
  .mobile-form-header {
    font-size: 24px;
    /* top: 45%; */
  }

  .mobile-gradient-button {
    padding: 10px 30px;
    font-size: 14px;
  }

  /* 调整左对齐的内边距 */
  .mobile-box-icon,
  .mobile-box-title,
  .mobile-box-content {
    padding-left: 15px; /* 小屏幕减少内边距 */
  }
}

/* 特别小的屏幕优化 */
@media (max-width: 360px) {
  .mobile-contact-box {
    height: 110px;
    min-height: 110px;
  }

  .mobile-box-icon {
    padding-top: 8px;
  }

  .mobile-box-icon img {
    width: 20px;
    /* height: 22px; */
  }

  .mobile-box-title {
    font-size: 14px;
    padding: 0 12px;
  }

  .mobile-box-content {
    font-size: 12px;
    padding: 0 12px 6px;
  }

  /* 调整左对齐的内边距 */
  .mobile-box-icon,
  .mobile-box-title,
  .mobile-box-content {
    padding-left: 12px; /* 特别小屏幕进一步减少内边距 */
  }
  .mobileform-footer-title {
    margin-top: 20px !important;
  }
  .mobile-form-container {
    top: 65%; /* 特别小屏幕稍微调整位置 */
  }

  .mobile-form-header {
    top: 40%; /* 特别小屏幕稍微调整位置 */
  }
}

/* 中等屏幕优化 */
@media (min-width: 481px) and (max-width: 850px) {
  .mobile-form-container {
    top: 38%; /* 中等屏幕稍微增加下移距离 */
  }

  .mobile-form-header {
    top: 25%; /* 中等屏幕稍微增加下移距离 */
  }
}
</style>
<style scoped>
/* 其他样式保持不变 */

/* 新增样式：单独的表单行 */
.form-single-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 22px;
}

.full-width-item {
  width: 100% !important;
  max-width: 100% !important;
}

/* 确保下拉选择器和文本域有相同的背景色和圆角 */
::v-deep.full-width-select .el-input__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 20px !important;
  width: 100% !important;
}

.full-width-select {
  width: 100% !important; /* 使用 !important 确保覆盖 */
  max-width: 100%; /* 防止超出父容器 */
  box-sizing: border-box; /* 重要的盒模型设置 */
}
/* 文本域特殊样式 */
::v-deep.message-textarea .el-textarea__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 20px !important;
  resize: none !important; /* 关键：隐藏拖拽图标并禁用拉伸 */
  min-height: 120px !important; /* 设置最小高度 */
  font-family: inherit !important;
  line-height: 1.5 !important;
}

/* 确保标签左对齐 */
::v-deep.full-width-item .el-form-item__label {
  text-align: left !important;
  display: block !important;
  width: 100% !important;
  padding-bottom: 8px !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
}

/* 调整表单项内部布局 */
::v-deep.full-width-item .el-form-item__content {
  width: 100% !important;
  margin-left: 0 !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .form-single-row {
    margin-bottom: 18px;
  }

  ::v-deep.message-textarea .el-textarea__inner {
    min-height: 100px !important;
  }
}
</style>
<style scoped>
.gradient-button {
  /* 基础样式 */
  padding: 12px 50px;
  border: none;
  border-radius: 50px; /* 圆角效果 */
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;

  /* 渐变背景 */
  background: linear-gradient(to right, #007bff, #28a745); /* 蓝色到绿色 */

  /* 过渡动画 */
  /* transition: all 0.3s ease; */

  /* 阴影效果（可选） */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* 悬停效果 */
/* .gradient-button:hover {
  background: linear-gradient(to right, #0069d9, #218838);
  
  transform: translateY(-1px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
} */

/* 点击效果（可选） */
/* .gradient-button:active {
  transform: scale(0.98);
} */
.contact-label {
  position: absolute;
  left: calc(50% + 17.5%);
  color: #212529;
  text-align: left;
  white-space: nowrap;
}
/* 修改后的等宽白框样式 */
.contact-boxes {
  position: absolute;
  top: 120%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
  width: 85%;
  max-width: 1400px;
  z-index: 10;
  gap: 2.5%;
}

.contact-box {
  flex: 1;
  min-width: 0;
  background: white;
  border-radius: 12px;
  padding: 20px 15px; /* 减少padding减小高度 */
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1),
    /* 右边阴影 */ 0 4px 12px rgba(0, 0, 0, 0.1); /* 底部阴影 */
  text-align: left;
  border: 1px solid #e0e0e0;
  color: #2c3e50;
  display: flex; /* 添加flex布局 */
  flex-direction: column; /* 垂直排列 */
}

.box-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0; /* 移除底部margin */
  min-height: 0; /* 允许内容收缩 */
  font-size: 18px;
  font-family: Cotyledon-Regular-bold;
  color: #2c3e50;
  flex: 1; /* 占据1/3空间 */
  align-self: stretch; /* 拉伸宽度 */
}

.box-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0; /* 允许内容收缩 */
  padding: 0; /* 移除额外padding */
  font-size: 12px;
  /* font-weight: 600; */
  word-wrap: break-word;
  line-height: 1.5;
  flex: 1; /* 占据2/3空间 */
  align-self: stretch; /* 拉伸宽度 */
}

/* 超大屏幕特别优化 */
@media (min-width: 1600px) {
  .form-container {
    top: 60% !important;
  }
  .form-title {
    top: 20% !important;
    font-size: 16px !important;
  }
  .form-footer-title {
    font-size: 25px !important;
  }
  .form-footer-neirong,
  .form-footer-littletitle {
    font-size: 16px !important;
  }
  .contact-boxes {
    width: 85%;
    max-width: 1600px;
    gap: 3%;
  }

  .contact-box {
    padding: 20px 15px; /* 统一中小屏幕padding */
    display: flex;
    flex-direction: column;
  }

  .box-row {
    font-size: 20px; /* 调整字体大小 */
    min-height: 30px; /* 统一最小高度 */
    flex: 1; /* 保持等分 */
  }

  .box-content {
    font-size: 14px;
    flex: 1; /* 保持等分 */
  }
}

/* 大屏幕调整 */
@media (min-width: 1201px) and (max-width: 1599px) {
  .form-container {
    top: 69% !important;
  }

  .form-title {
    top: 19% !important;
    font-size: 15px !important;
  }
  .form-footer-title {
    font-size: 20px !important;
  }
  .form-footer-neirong,
  .form-footer-littletitle {
    font-size: 15px !important;
  }
  .contact-boxes {
    width: 87%; /* 大屏幕保持较宽 */
  }
}

/* 中等屏幕调整 */
@media (max-width: 1200px) {
  .form-container {
    top: 69% !important;
  }
  .contact-boxes {
    width: 88%; /* 中等屏幕进一步加宽 */
    gap: 2%;
  }

  .contact-box {
    padding: 22px 18px;
  }

  .box-row {
    font-size: 18px;
  }

  .box-content {
    font-size: 14px;
  }
}

/* 小屏幕PC调整 */
@media (max-width: 992px) {
  .contact-boxes {
    width: 92%; /* 小屏幕PC更宽，接近全屏 */
    gap: 1.5%;
  }

  .contact-box {
    padding: 18px 15px;
  }

  .box-row {
    font-size: 16px;
    margin-bottom: 14px;
  }

  .box-content {
    font-size: 14px;
    min-height: 60px;
  }
}

/* 平板和移动端调整 */
@media (max-width: 768px) {
  .contact-boxes {
    flex-direction: column;
    gap: 20px;
    width: 90%; /* 移动端也保持较宽 */
  }

  .contact-box {
    width: 100%;
    padding: 20px;
  }

  .box-row {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .box-content {
    font-size: 15px;
    min-height: auto;
  }
}

/* 小屏幕手机特别优化 */
@media (max-width: 480px) {
  .contact-boxes {
    width: 95%; /* 小手机几乎全宽 */
    gap: 15px;
  }

  .contact-box {
    padding: 15px;
  }

  .box-row {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .box-content {
    font-size: 14px;
  }
}
/* .box-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 60px;
  padding: 5px 0;
} */

.icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
/* form表单 */
/* 标签左对齐 */
.el-form-item__label {
  font-size: 14px !important;
  font-weight: normal !important;
  text-align: left !important;
  padding-right: 15px;
  color: #2c3e50;
}
::v-deep.contact-form .el-form-item__label {
  font-size: 15px;
  font-weight: normal !important; /* 去除加粗 */
  padding-bottom: 4px !important;
  line-height: 25px !important;
}
/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 2px !important;
}
/* 新增输入框圆角和灰色背景 */
::v-deep.rounded-input .el-input__inner {
  font-size: 15px !important;
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 20px !important;
}
.form-footer {
  text-align: left !important;
  width: 100%;
  padding: 15px;
  margin: auto;
  max-width: 65%;
}
.form-footer-title {
  font-size: 24px;
  font-family: Cotyledon-Regular-bold;
}
.form-footer-littletitle {
  font-size: 14px;
  font-family: Cotyledon-Regular-bold;
  margin-top: 25px;
}
.form-footer-neirong {
  font-size: 14px;
}
.mobileform-footer {
  text-align: left !important;
  width: 100%;
  padding: 15px;
  margin: auto;
  max-width: 85%;
}
.mobileform-footer-title {
  font-size: 24px;
  font-family: Cotyledon-Regular-bold;
}
.mobileform-footer-littletitle {
  font-size: 14px;
  font-family: Cotyledon-Regular-bold;
  margin-top: 20px;
}
.mobileform-footer-neirong {
  font-size: 14px;
}
/* 表单容器样式 */
.form-container {
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 65%;
  background: rgba(255, 255, 255, 0.91);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1),
    /* 右边阴影 */ 0 4px 12px rgba(0, 0, 0, 0.1); /* 底部阴影 */
  z-index: 10;
}
.form-title {
  position: absolute;
  top: 19%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 65%;
  text-align: center;
  font-size: 14px;
  margin-bottom: 30px;
  color: #2c3e50;
}
.form-header {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 65%;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #2c3e50;
  font-family: Cotyledon-Regular-bold;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 45px !important;
}

.form-row {
  display: flex;
  gap: 12px;
  text-align: left;
}

.form-row > * {
  flex: 1;
}

.submit-button {
  margin-top: 50px;
  text-align: center;
}

/* .submit-btn {
  width: 200px;
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 50px;
  background: #409eff;
  border: none;
} */

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 10px;
  }

  .form-container {
    width: 90%;
    padding: 20px;
  }

  .submit-btn {
    width: 150px;
    height: 45px;
  }
}
::v-deep.el-form--label-top .el-form-item__label {
  padding: 0 0 0px !important;
}
</style>
